import { render, staticRenderFns } from "./NormalSearchNav267.vue?vue&type=template&id=27b68c20&scoped=true"
import script from "./NormalSearchNav267.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav267.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b68c20",
  null
  
)

export default component.exports